import { ROUTE_PATHS } from "../../consts";

export const getCompanyUrl = (id: string): string =>
  `/${ROUTE_PATHS.companies}/company/${id}`;
